import { render, staticRenderFns } from "./addInsect.vue?vue&type=template&id=04ed366a&scoped=true&"
import script from "./addInsect.vue?vue&type=script&lang=js&"
export * from "./addInsect.vue?vue&type=script&lang=js&"
import style0 from "./addInsect.vue?vue&type=style&index=0&id=04ed366a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed366a",
  null
  
)

export default component.exports